import { render, staticRenderFns } from "./Question13.vue?vue&type=template&id=abc86d26&scoped=true&"
import script from "./Question13.vue?vue&type=script&lang=js&"
export * from "./Question13.vue?vue&type=script&lang=js&"
import style0 from "./Question13.vue?vue&type=style&index=0&id=abc86d26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abc86d26",
  null
  
)

export default component.exports